/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Number_RangeInputs */

const th_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หมายเลขเสื้อต้องอยู่ระหว่าง 0 ถึง 99`)
};

const en_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A squad number is 0 to 99.`)
};

const ja_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背番号は0から99です。`)
};

const zh_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球衣号码从 0 到 99。`)
};

const es_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El dorsal va de 0 a 99.`)
};

const pt_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número da camisa vai de 0 a 99.`)
};

const id_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nomor punggung dari 0 sampai 99.`)
};

const fr_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un numéro de maillot va de 0 à 99.`)
};

const tl_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mula 0 hanggang 99 ang numero ng damit.`)
};

const vi_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số áo từ 0 đến 99.`)
};

const ko_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등번호는 0부터 99까지입니다.`)
};

const de_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Trikotnummer geht von 0 bis 99.`)
};

const ru_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игровой номер — от 0 до 99.`)
};

const tr_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma numarası 0 ile 99 arasındadır.`)
};

const it_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il numero di maglia va da 0 a 99.`)
};

const pl_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numer na koszulce to od 0 do 99.`)
};

const uk_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігровий номер — від 0 до 99.`)
};

const hi_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जर्सी नंबर 0 से 99 तक होता है।`)
};

const ar_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقم القميص من 0 إلى 99.`)
};

const ms_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombor jersi ialah 0 hingga 99.`)
};

const bn_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জার্সি নম্বর ০ থেকে ৯৯।`)
};

const zh_tw2_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球衣號碼為 0 到 99。`)
};

const zh_hk2_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球衣號碼為 0 到 99。`)
};

const ur_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شرٹ نمبر 0 سے 99 تک ہوتا ہے۔`)
};

const fa_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شمارهٔ پیراهن از ۰ تا ۹۹ است.`)
};

const sw_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namba ya jezi ni kuanzia 0 hadi 99.`)
};

const nl_player_number_range = /** @type {(inputs: Player_Number_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een rugnummer loopt van 0 tot 99.`)
};

/**
* | output |
* | --- |
* | "A squad number is 0 to 99." |
*
* @param {Player_Number_RangeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_number_range = /** @type {((inputs?: Player_Number_RangeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Number_RangeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_number_range(inputs)
	if (locale === "ja") return ja_player_number_range(inputs)
	if (locale === "zh") return zh_player_number_range(inputs)
	if (locale === "es") return es_player_number_range(inputs)
	if (locale === "pt") return pt_player_number_range(inputs)
	if (locale === "id") return id_player_number_range(inputs)
	if (locale === "fr") return fr_player_number_range(inputs)
	if (locale === "tl") return tl_player_number_range(inputs)
	if (locale === "vi") return vi_player_number_range(inputs)
	if (locale === "ko") return ko_player_number_range(inputs)
	if (locale === "de") return de_player_number_range(inputs)
	if (locale === "ru") return ru_player_number_range(inputs)
	if (locale === "tr") return tr_player_number_range(inputs)
	if (locale === "it") return it_player_number_range(inputs)
	if (locale === "pl") return pl_player_number_range(inputs)
	if (locale === "uk") return uk_player_number_range(inputs)
	if (locale === "hi") return hi_player_number_range(inputs)
	if (locale === "ar") return ar_player_number_range(inputs)
	if (locale === "ms") return ms_player_number_range(inputs)
	if (locale === "bn") return bn_player_number_range(inputs)
	if (locale === "zh-TW") return zh_tw2_player_number_range(inputs)
	if (locale === "zh-HK") return zh_hk2_player_number_range(inputs)
	if (locale === "ur") return ur_player_number_range(inputs)
	if (locale === "fa") return fa_player_number_range(inputs)
	if (locale === "sw") return sw_player_number_range(inputs)
	if (locale === "nl") return nl_player_number_range(inputs)
	return en_player_number_range(inputs)
});